import AboutUs from 'components/AboutUs/AboutUs'

export default AboutUs